import type { APIResponse, Project } from '@yourownmetric/shared'

import { apiSlice } from './apiSlice'

interface CreateProjectPayload {
    name: string
    domain: string
    timezone?: string
}

export const projectsApi = apiSlice.injectEndpoints({
    endpoints: builder => ({
        listProjects: builder.query<Project[], void>({
            query: () => '/projects',
            transformResponse: (res: APIResponse<Project[]>) => res.data!,
            providesTags: ['Projects'],
        }),

        createProject: builder.mutation<Project, CreateProjectPayload>({
            query: body => ({
                url: '/projects',
                method: 'POST',
                body,
            }),
            transformResponse: (res: APIResponse<Project>) => res.data!,
            invalidatesTags: ['Projects'],
        }),
    }),
})

export const { useListProjectsQuery, useCreateProjectMutation } = projectsApi
